import axios from '@/axiosInterceptor';
const state = () => ({
  truckerTools: {
    carrierElds: [],
    availableElds: [],
    isActive: false,
    channelId: null,
  },
  updateEld: false,
});

// getters
const getters = {};

// actions
const actions = {
  //Trucker tool:
  async getCarrierElds({ commit }, channelId) {
    try {
      const res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/trucker_tools/carrier_elds?channel_id=${channelId}`
      );
      commit('setCarrierElds', res.data);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getAvailableEldTypes({ commit }, channelId) {
    try {
      const res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/trucker_tools/available_eld_types?channel_id=${channelId}`
      );
      commit('setAvailableElds', res.data);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getTruckerSignUpURL(_, eld_provider_code) {
    try {
      const res = axios.get(
        `${process.env.API_IDENTITY}/api/v1/trucker_tools/signup_url?eld_provider_code=${eld_provider_code}`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setCarrierElds(state, data) {
    state.truckerTools.carrierElds = data;
  },
  setAvailableElds(state, data) {
    state.truckerTools.availableElds = data;
  },
  setActiveTruckerTools(state, boolean) {
    state.truckerTools.isActive = boolean;
  },
  setTruckerToolChannelId(state, number) {
    state.truckerTools.channelId = number;
  },
  setUpdateEld(state, bool) {
    state.updateEld = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
